export default "__VITE_ASSET__xbmWCWMr__"